import { render, staticRenderFns } from "./MasterPureRisk.vue?vue&type=template&id=ec41db10&"
import script from "./MasterPureRisk.vue?vue&type=script&lang=js&"
export * from "./MasterPureRisk.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports